import { differenceInCalendarDays, format, startOfDay } from "date-fns";
import { cs } from "date-fns/locale/cs";
import { parseTimelineDate } from "web_myplann/NotificationCenter/Utils/parseTimelineDate";
import { DEFAULT_DATE_FORMAT } from "web_myplann/Shared/Utils/dateFormatters";

export const formatTimelineDate = (isoDate: string): string =>
	format(parseTimelineDate(isoDate), DEFAULT_DATE_FORMAT, { locale: cs });

export type RelativeDateLabels = {
	today: string;
	yesterday: string;
	daysAgo: (count: number) => string;
	weeksAgo: (count: number) => string;
	monthsAgo: (count: number) => string;
};

const DAYS_PER_WEEK = 7;
const DAYS_PER_MONTH = 30;

export const formatRelativeTimelineDate = (
	isoDate: string,
	today: Date,
	labels: RelativeDateLabels,
): string => {
	const diff = differenceInCalendarDays(
		startOfDay(today),
		parseTimelineDate(isoDate),
	);

	if (diff === 0) return labels.today;
	if (diff === 1) return labels.yesterday;
	if (diff >= DAYS_PER_MONTH) {
		return labels.monthsAgo(Math.floor(diff / DAYS_PER_MONTH));
	}
	if (diff >= DAYS_PER_WEEK) {
		return labels.weeksAgo(Math.floor(diff / DAYS_PER_WEEK));
	}
	if (diff > 1) return labels.daysAgo(diff);
	return formatTimelineDate(isoDate);
};
